import * as yup from "yup";

export const CreateWebinarSchema = yup.object().shape({
  event_title: yup.string().required("Event title is required"),
  description: yup.string().optional(),
  start_date: yup.date().required("Start date & time is required"),
  end_date: yup.date().required("End date & time is required"),
  event_type: yup
    .string()
    .oneOf(["online", "in_person"])
    .required("Event type is required"),
  event_link: yup.string().when("event_type", {
    is: (val: any) => val === "online",
    then: (schema) =>
      schema
        .required("Event link is required")
        .url("Event link must be a valid URL"),
    otherwise: (schema) => schema.optional(),
  }),

  event_address: yup.string().when("event_type", {
    is: (val: any) => val === "in_person",
    then: (schema) => schema.required("Event Address is required"),
    otherwise: (schema) => schema.optional(),
  }),
  host: yup.string().required("Host is required"),
});

export const attendeeValidationSchema = yup.object().shape({
  first_name: yup
    .string()
    .required("First Name is required")
    .max(50, "First Name must be at most 50 characters"),

  last_name: yup
    .string()
    .required("Last Name is required")
    .max(50, "Last Name must be at most 50 characters"),

  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),

  contact_number: yup.string().required("Phone Number is required"),
});
